import React, { Component } from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import { stableSort, getSorting} from '../Common/helpers';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import ModalBox from '../Common/Modals/ModalBox';
import AutoSug from '../Common/AutoSug/AutoSug';

import { API } from '../../ws/constants';

import './style.css';

var moment = require('moment');

class PrintPayments extends Component {
    /* START Constructor */

    constructor(props) {
        super(props);
        const Payments = this.props.loginData.profile.Payments;
        
        this.state = {
            fetchStores:null
            ,fetchStaff:null
            ,fetchClients:null
            ,fetchPayments:null
            ,fetchPaymentTypes:null
            // filter Stuff
            ,order:props.props.match.params.order
            ,orderBy:props.props.match.params.orderBy
            ,page:props.props.match.params.page
            ,rowsPerPage: props.props.match.params.rowsPerPage
            ,storeFilter: props.props.match.params.store ? props.props.match.params.store : [""] 
            ,clientFilterId:props.props.match.params.client ? props.props.match.params.client : ""
            ,staffFilterId:props.props.match.params.staff ? props.props.match.params.staff : ""
            ,dateFilter: moment(parseInt(props.props.match.params.date, 10))
            ,grandTotal: 0.00
        };
    }

    /* END Constructor */

    /* START React own Functions */

    componentDidMount() {
        const fetches = [fetch(API + "getstores"), fetch(API + "getstaff"), fetch(API + "getclients&onlyactive=true"), fetch(API + "getpaymenttypes")];
        this.setState({tableLoading:true});

        Promise.all(fetches)
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then((data) => {
            this.setState({
                fetchStores:data[0].data,
                fetchStaff:data[1].data,
                fetchClients:data[2].data,
                fetchPaymentTypes:data[3].data,
            });
        });
        this.getPayments();
    }

    /* END React own Functions */

    /* START Component Functions */

    getPayments = () => {
        const { storeFilter, clientFilterId, staffFilterId, dateFilter } = this.state;
        const { isAdmin, loginData } = this.props;
        const Payments = loginData.profile.Payments;
        let queryParams = "&getbycreatedby=" + this.props.loginData.Id;

        if((isAdmin || (Payments && Payments.viewAllPayments))){
            let storeQuery = ""
                , clientQuery = ""
                , staffQuery = ""
                , dateQuery = "";

            if(storeFilter.length >= 1 && storeFilter[0] !== "") storeQuery = "&getbystoreids=" + storeFilter.join(",");
            if(clientFilterId) clientQuery = "&getbyclientid=" + clientFilterId;
            if(staffFilterId) staffQuery = "&getbystaffid=" + staffFilterId;
            if(dateFilter) dateQuery = "&getbydate=" + dateFilter.format('YYYY-MM-DD');

            queryParams = storeQuery + clientQuery + staffQuery + dateQuery;
        }

        fetch(API + "getpayments" + queryParams)
        .then(response => response.json())
        .then(data => this.setState({
            fetchPayments: data.data.payments,
            grandTotal: data.data.totals.GrandTotal,
            loading: false
        }));
    }

    /* END Component Functions */

    /* START Renders */

    renderStoresOptions = (multiple) => {
        const stores = this.state.fetchStores;
        if(stores===null)
            return;
        const items = multiple ? [<MenuItem value="" key="0">Todas as Lojas</MenuItem>] : [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=stores.length;i<n;i++) {
            const item = multiple ?
                         <MenuItem value={stores[i].Id}
                                   key={stores[i].Id}
                                   checked={this.state.storeFilter && this.state.storeFilter.indexOf(stores[i].Id) > -1}
                                   className="insetItem">{stores[i].Name + " - " + stores[i].Shortname}
                         </MenuItem>
                         :
                         <MenuItem value={stores[i].Id} key={stores[i].Id}>
                            {<div><div className="smallColorDiv" style={{backgroundColor: stores[i].Color}}></div> <span>{stores[i].Name + " - " + stores[i].Shortname}</span></div>}
                         </MenuItem>;

            items.push(item);
        }
        return items;
    }

    renderPaymentOptions = (e) => {
        const payments = this.state.fetchPaymentTypes;
        if(payments===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=payments.length;i<n;i++) {
            items.push(<MenuItem value={payments[i].Id}
                                 key={payments[i].Id}>
                                    {<div><div className="smallImage"><img src={payments[i].Image} alt={payments[i].Shortname} /></div> <span>{payments[i].Name}</span></div>}
                       </MenuItem>);
        }
        return items;
    }

    /* END Renders */

    render() {
        const { isAdmin, loginData } = this.props;

        const { dateName, fetchPayments } = this.state
              , loadingClass = this.state.loading ? " ajaxLoading" : ""
              , Payments = loginData.profile.Payments
              , paymentCount = fetchPayments ? fetchPayments.length : 1
              , { order, orderBy, rowsPerPage, page } = this.state
              , headerRows = [
                  { id: 'StoreName', active: true, numeric: false, label: 'Loja' },
                  { id: 'ClientFullName', numeric: false, label: 'Cliente' },
                  { id: 'StaffFullName', numeric: false, label: 'Funcionário' },
                  { id: 'PaymentDate', numeric: false, className: 'midHeader', label: 'Data' },
                  { id: 'DateCreated', numeric: false, className: 'midHeader', label: 'Data Criação' },
                  { id: 'PaymentType', numeric: false, className: 'midSmallHeader', label: 'Método' },
                  { id: 'PaymentValue', numeric: false, className: 'midHeader', label: 'Valor' },
              ];
        let pageTotal = 0;

        return (
            <div id="paymentsPage">
                <div>
                    <div className="pageHeader normalMarginTop">
                        <h1><i className="fa fa-cash-register"></i> Pagamentos {dateName}</h1>
                    </div>
                    <Table className={"responsiveTable customTable" + loadingClass}>
                        <EnhancedTableHead
                            className="tableRow tableHeader"
                            headerRows={headerRows}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={paymentCount}>
                        </EnhancedTableHead>
                        <TableBody>
                            {fetchPayments && stableSort(fetchPayments, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(payment => { pageTotal += parseFloat(payment.PaymentValue)
                                    return (
                            <TableRow key={payment.Id} className="tableRow" ref={"payment_" + payment.Id}>
                                <TableCell data-title="Loja" className="tableCell"><div className="smallColorDiv" style={{backgroundColor: payment.StoreColor}}></div> {payment.StoreName}</TableCell>
                                <TableCell data-title="Cliente" className="tableCell">
                                    {payment.ClientFirstName} {payment.ClientLastName}
                                </TableCell>
                                <TableCell data-title="Funcionário" className="tableCell">{payment.StaffFullName}</TableCell>
                                <TableCell data-title="Data" className="tableCell midCell">{moment(payment.PaymentDate).format("DD-MM-YYYY")}</TableCell>
                                <TableCell data-title="Data Criação" className="tableCell midCell">
                                    <Tooltip
                                        title={"Criado em " + moment(payment.DateCreated).format("DD-MM-YYYY") + " pelo utilizador " + payment.UserName + " ("+ payment.UserUserName +")"}
                                        enterDelay={200}>
                                        <b>{moment(payment.DateCreated).format("DD-MM-YYYY HH:mm")}</b>
                                    </Tooltip>
                                </TableCell>
                                <TableCell data-title="Método" className="tableCell midSmallCell">
                                    <Tooltip
                                        title={"Método de pagamento usado: " + payment.PaymentTypeName}
                                        enterDelay={200}>
                                        <b>{payment.PaymentTypeShortname}</b>
                                    </Tooltip>
                                </TableCell>
                                <TableCell data-title="Valor" className="tableCell midCell">
                                    <Tooltip
                                        title={"Tipo de pagamento utilizado foi " + payment.PaymentTypeName + ". Criador original: "+ payment.OriginalUserName +" ("+ payment.OriginalUserUserName + "), última modificação: " + payment.UserName +" ("+ payment.UserUserName +")" }
                                        enterDelay={200}>
                                        <b>{parseFloat(payment.PaymentValue).toFixed(2) + "€"}</b>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        )})}
                        { (isAdmin || (Payments && Payments.viewTotals)) && 
                            <TableRow key="999999" className="tableRow">
                                <TableCell className="tableCell" colSpan="6"></TableCell>
                                <TableCell className="tableCell totalsRow"><h4>Total Página</h4><p>{parseFloat(pageTotal).toFixed(2) + "€"}</p></TableCell>
                                <TableCell className="tableCell totalsRow"><h4>Valor total</h4><p>{this.state.grandTotal + "€"}</p></TableCell>
                            </TableRow>
                        }
                        </TableBody>
                    </Table>
				</div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default PrintPayments;
